"use client";

import Layout from "@components/layout/landing/Layout";
import Hero5 from "@components/sections/hero/Hero5";
import Category from "@components/sections/categories/Category";
import CategoryProfession from "@components/sections/categories/CategoryProfession";
import CitySection from "@components/sections/city/City";
import BlogSection1 from "@components/sections/blog/BlogSection1";

const Home = ({ category, city, profession, pages = { pages }, allCity, allProfession, allCategory, blog }) => {
  return (
    <>
      <Layout headerStyle={5} pages={pages}>
        <Hero5
          pages={pages}
          allCity={allCity}
          allProfession={allProfession}
          allCategory={allCategory} />
        <Category category={category} pages={pages} />
        <CategoryProfession profession={profession} pages={pages} />
        <CitySection city={city} pages={pages} />
        <BlogSection1 pages={pages} blog={blog} />
      </Layout>
    </>
  );
};

export default Home;
